import {apiGlobal} from './index'
import {LOCAL_STORAGE} from '@utils/Const'

const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)

export const learnPartTwoEndPoints = {
  INIT_SESSION: 'iesv/api/v1/ielts/learning/sessions',
  GET_DATA: 'iesv/api/v1/ielts/learning/sessions',
  GET_USER_IDEA: 'iesv/api/v1/ielts/learning/sessions',
  SUBMIT_OUTLINE: 'iesv/api/v1/ielts/learning/sessions',
  GET_DATA_PRACTICE_IDEA: 'iesv/api/v1/ielts/learning/sessions',
  STT: 'iesv/api/v1/ielts/fast-tracks/retrieve-texts',
  CHECK_ANSWERS: 'iesv/api/v1/ielts/learning/sessions',
  GET_SUMMARY: 'iesv/api/v1/ielts/learning/sessions',
  GET_SCORE: 'iesv/api/v1/ielts/learning/sessions',
  SAVE_STEP: 'iesv/api/v1/ielts/learning/sessions',
}

const learnPartTwoRequest = {
  initSession: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(learnPartTwoEndPoints.INIT_SESSION, params)
    }
  },
  getData: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartTwoEndPoints.GET_DATA}/${params.session_id}`,
        {},
      )
    }
  },
  getUserIdea: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartTwoEndPoints.GET_USER_IDEA}/${params.session_id}/part-2-user-ideas`,
        {},
      )
    }
  },
  submitOutline: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartTwoEndPoints.SUBMIT_OUTLINE}/${params.session_id}/user-ideas`,
        params,
      )
    }
  },
  getDataPracticeIdea: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartTwoEndPoints.GET_DATA_PRACTICE_IDEA}/${params.session_id}/practice-ideas`,
        {},
      )
    }
  },
  stt: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(learnPartTwoEndPoints.STT, params, {}, true)
    }
  },
  checkAnswers: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartTwoEndPoints.CHECK_ANSWERS}/${params?.session_id}/practice-ideas/check-answers`,
        params?.form_data,
        {},
        true,
      )
    }
  },
  getSummary: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authGet(
        `${learnPartTwoEndPoints.GET_SUMMARY}/${params?.session_id}/practice-ideas/summaries`,
        {},
      )
    }
  },
  getScore: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartTwoEndPoints.GET_SCORE}/${params?.session_id}/part-2-scores`,
        params?.form_data,
        {},
        true,
      )
    }
  },
  saveStep: (params: any) => {
    if (getAccessToken()) {
      return apiGlobal.authPost(
        `${learnPartTwoEndPoints.SAVE_STEP}/${params?.session_id}/steps`,
        params,
      )
    }
  },
}

export default learnPartTwoRequest
